<template>
    <div>
        行业新闻详情
    </div>
</template>

<script>
export default {
    mounted() {
        this.$parent.isShow = false
    }
}
</script>